import { createFileRoute, redirect, isRedirect } from "@tanstack/react-router";
import { isAuthenticated } from "@/integrations/api/auth";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";
import { AppShell } from "@/components/shell/AppShell";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async ({ context }) => {
    if (!isAuthenticated()) {
      throw redirect({ to: "/auth" });
    }

    try {
      // ensureQueryData returns cached data if still fresh (within staleTime),
      // otherwise fetches. AppShell's useQuery(currentUserQueryOptions()) will
      // then read from cache — no second /api/auth/me request.
      const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());

      // Keep auth store in sync for RBAC helpers that read from zustand directly.
      const { useAuthStore } = await import("@/store/useAuthStore");
      const store = useAuthStore.getState();
      if (!store.isAuthenticated || !store.profile) {
        store.setAuth(me);
      }

      if (me.must_change_password) {
        throw redirect({ to: "/change-password" });
      }

      return { user: { id: me.user!.id, email: me.user!.email } };
    } catch (err) {
      // Re-throw redirects (e.g. to /change-password) so they are not swallowed
      if (isRedirect(err)) throw err;
      throw redirect({ to: "/auth" });
    }
  },
  component: AppShell,
});
